import axios from 'axios';

import { env } from '@/shared/config/env';

import { toApiError } from './api-error';

export const publicClient = axios.create({
  baseURL: env.apiUrl,
  timeout: 15_000,
  headers: { Accept: 'application/json' },
});

publicClient.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(toApiError(error)),
);
